module.exports = __webpack_public_path__ + "static/media/red.8b36a800.png";